// removed by extract-text-webpack-plugin
module.exports = {"root":"_3OBind-hJsOwGzuU3M6niQ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/breadcrumb.scss
// module id = 1320
// module chunks = 0